import { FaArrowLeft, FaArrowRight } from '../../../icons/index';
import styles from './SliderControls.module.scss';

export default function SliderControls({
  showLeft,
  showRight,
  onLeft,
  onRight,
}) {
  if (!showLeft && !showRight) return null;

  return (
    <div className={styles.controls}>
      {showLeft && (
        <button onClick={onLeft} className={styles.btn}>
          <FaArrowLeft />
        </button>
      )}

      {showRight && (
        <button onClick={onRight} className={styles.btn}>
          <FaArrowRight />
        </button>
      )}
    </div>
  );
}
